import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { Sale } from '../../../models/sale/sale.model';
import { Tip } from '../../../models/tip/tip.model';
import { Stylist } from '../../../models/stylist/stylist.model';
import { Utilities } from '../../../utilities/utilities';
import { UserService } from '../../../services/user.service';
import { MaskitoOptions, MaskitoElementPredicateAsync } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';

export interface SaleTipFormModalCallBackData {
  tip: Tip,
  action: string
}
@Component({
  selector: 'app-sale-tip-form',
  templateUrl: './sale-tip-form.page.html',
  styleUrls: ['./sale-tip-form.page.scss'],
})
export class SaleTipFormPage implements OnInit {
  @Input() sale: Sale;

  @Input() tip: Tip;

  public tipForm2: UntypedFormGroup;

  public tipField2 : UntypedFormControl;

  @Input() showRemoveButton: boolean;

  public isStylistPickerLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  currency: string;
  currencyMask: MaskitoOptions;

  readonly maskPredicate: MaskitoElementPredicateAsync = async (el) =>
    (el as HTMLIonInputElement).getInputElement();

  public submitted: boolean;

  public isIOS: boolean;

  constructor (
               //private navParams: NavParams,
              //private viewCtrl: ViewController,
              private userService: UserService,
              private formBuilder: UntypedFormBuilder,
              private modalCtrl: ModalController,
              public platform: Platform) {
    //this.sale = this.navParams.get('sale');
    //this.tip = this.navParams.get('tip');
    //this.showRemoveButton = this.navParams.get('showRemoveButton');
   
  }

  public ngOnInit () {
    if(this.platform.is('ios')) this.isIOS = true;
    this.tipField2 = new UntypedFormControl(this.tip.value, Validators.required);
    this.tipForm2 = this.formBuilder.group({
      tiptip2: this.tipField2
    });
    this.isStylistPickerLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.currency = Utilities.decodeHTML(
      this.userService.getSalon().getCurrency()
    );

    this.currencyMask = maskitoNumberOptionsGenerator({
      decimalZeroPadding: true,
      precision: 2,
      decimalSeparator: '.',
      thousandSeparator: ',',
      min: 0,
      prefix: this.currency,
    });

  }

  public onDismiss () {
    //this.viewCtrl.dismiss();
    // const data: SaleTipFormModalCallBackData = {
    //   tip: this.tip.setValue(Utilities.extractNumberFromString(this.tipField2.value)),
    //   action: 'save'
    // };
    this.modalCtrl.dismiss();
    
  }

  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) {
    this.isStylistPickerLoading = false;
    
    if (initResponse.success) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.tip = this.tip.setStylist(stylist);
  }

  public save () {

    this.submitted = true;

    if (!this.tipForm2.valid) {
      return;
    }
   

    const data: SaleTipFormModalCallBackData = {
      tip: this.tip.setValue(Utilities.extractNumberFromString(this.tipField2.value)),
      action: 'save'
    };

    this.modalCtrl.dismiss(data);
  }

  public remove () {
    const data: SaleTipFormModalCallBackData = {
      tip: this.tip,
      action: 'remove'
    };

    //this.viewCtrl.dismiss(data);
    this.modalCtrl.dismiss(data);
  }

}
